import { REDUX_STORE } from '../../../constants/common';
import { getMaterialsList } from '../../../selectors/news';

type TLoadMore = () => Promise<void>;

export const mainPageInfiniteScroll = (loadMore: TLoadMore, elem: HTMLDivElement, isNews: boolean) => {
  const handleIntersect: IntersectionObserverCallback = (entries) => {
    const { getState } = window[REDUX_STORE];

    const list = getMaterialsList(getState());
    const triggerMaterial = list[list.length - (isNews ? 4 : 2)];

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (triggerMaterial?.alias) {
          loadMore();
        }
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersect, {});
  observer.observe(elem);

  return {
    remove: () => observer?.disconnect(),
  };
};
